"use client";
import { PropsWithChildren, useEffect } from "react";
import { CategoryWithSubcategories, SampleAttribute } from "@/types/shared";
import { useAppDispatch, useAppSelector } from "@/store";
import { categoriesSelector, setCategories } from "@/store/categories/categoriesSlice";
import { setIsWritingService } from "@/store/global/globalSlice";
import { useCopySuffix } from "@/utils/useCopySuffix";

type MenuProviderProps = PropsWithChildren<{
  categories: CategoryWithSubcategories[];
  isWritingService: boolean;
}>;
export const AppProvider = ({ children, categories, isWritingService }: MenuProviderProps) => {
  const cachedCategories = useAppSelector(categoriesSelector);
  const dispatch = useAppDispatch();
  if (!cachedCategories.length) {
    dispatch(setCategories(categories));
    dispatch(setIsWritingService(isWritingService));
  }

  useCopySuffix();

  return <>{children}</>;
};
